<nz-spin nzTip="Carregando..." [nzSpinning]="loading">
  <span>Selecione o limite de meses a serem exibidos:</span>
  <nz-slider [nzMarks]="marks" nzDots [(ngModel)]="qtdRegistros" (nzOnAfterChange)="loadChart()"></nz-slider>
  <canvas baseChart [data]="{ labels: lineChartLabels, datasets: lineChartData }" [options]="lineChartOptions"
    [type]="lineChartType">
  </canvas>
</nz-spin>